<script setup lang="tsx">
import { onBeforeMount, ref } from 'vue'
import Multiselect from 'vue-multiselect'
import type { User, Response } from '@/models/api-generated'
import http from '@/services/http'

const props = defineProps({
	placeholder: {
		default: '',
	},
	multiple: {
		default: false,
	},
})
const isLoading = ref(false)
const model = defineModel<User | User[] | undefined>({ required: true })
const options = ref<User[]>([])

onBeforeMount(() => search(''))

async function search(q: string) {
	isLoading.value = true

	const { data } = await http.get<Response<User[]>>('api/users?showActive=true&q=' + q)

	options.value = data.data ?? []

	isLoading.value = false
}
</script>

<template>
	<Multiselect
		:placeholder="props.placeholder"
		:multiple="props.multiple"
		:show-labels="false"
		:hide-selected="props.multiple"
		:options="options"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="model"
		label="label"
		track-by="id"
		@search-change="search"
	>
	</Multiselect>
</template>
